module.exports = "<ngb-alert *ngIf=\"_Message\" [type]=\"type\" (close)=\"close();\">{{ _Message }}</ngb-alert>"